export default "__VITE_ASSET__CwCiRuAS__"